module.exports = __webpack_public_path__ + "img/标准文件6.329eac72.png";